/*
 * File: UICheckboxGroup.js
 * Project: mp-mobile-app
 *
 * Created by jeddumire on 10/08/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Group of checkboxes that can have a "check all" switch at the top
 */
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import UISwitchAll from "./UISwitchAll";
import UICheckbox from "./UICheckbox";

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

const UICheckboxGroup = ({ field }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {field.hasCheckAll && <UISwitchAll field={field} />}
      {field.options.map((option, idx) => {
        return <UICheckbox option={option} field={field} key={idx} />;
      })}
    </div>
  );
};

UICheckboxGroup.propTypes = {
  field: PropTypes.object.isRequired
};

export default UICheckboxGroup;
